"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var checkbox_1 = tslib_1.__importDefault(require("../checkbox"));
var empty_state_1 = tslib_1.__importDefault(require("../empty-state"));
var DirectionRight_1 = require("../Icons/DirectionRight");
var input_1 = tslib_1.__importDefault(require("../input"));
var widthAnq_1 = tslib_1.__importDefault(require("../widthAnq"));
var utils_1 = require("./utils");
var Search = input_1.default.Search;
var AnqCheckBox = (0, widthAnq_1.default)(checkbox_1.default, {
    config: { prefixCls: 'anq' },
});
var SelectableContainer = function (props) {
    var _a, _b;
    var title = props.title, _c = props.dataSource, _dataSource = _c === void 0 ? [] : _c, rowSelection = props.rowSelection, className = props.className, onItemFocus = props.onItemFocus, onSelect = props.onSelect, onSelectAll = props.onSelectAll, hasFilter = props.hasFilter, singleSelect = props.singleSelect, hideTitle = props.hideTitle, defaultFocus = props.defaultFocus, lastPanelStyle = props.lastPanelStyle, parentRecord = props.parentRecord, depth = props.depth;
    var _d = parentRecord || {}, placeholder = _d.placeholder, showSearch = _d.showSearch, loadChildren = _d.loadChildren;
    var _e = tslib_1.__read((0, react_1.useState)(_dataSource || []), 2), dataSource = _e[0], setDataSource = _e[1];
    var _f = tslib_1.__read((0, react_1.useState)(''), 2), searchValue = _f[0], setSearchValue = _f[1];
    var _g = rowSelection || {}, hideSelectAll = _g.hideSelectAll, selectedRowKeys = _g.selectedRowKeys, focusKeys = _g.focusKeys, indeterminateRowKeys = _g.indeterminateRowKeys, renderCell = _g.renderCell;
    (0, react_1.useEffect)(function () {
        setDataSource(_dataSource || []);
    }, [_dataSource]);
    var _onSearch = (0, debounce_1.default)(function (keyword) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var dataSource_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!loadChildren) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadChildren(keyword)];
                case 1:
                    dataSource_1 = _a.sent();
                    setDataSource(dataSource_1 || []);
                    _a.label = 2;
                case 2:
                    setSearchValue(keyword);
                    return [2 /*return*/];
            }
        });
    }); }, 300);
    var numberOfItemStatus = (0, react_1.useMemo)(function () {
        return (0, utils_1.getStatusOfCheckUsingKeys)(dataSource, selectedRowKeys, indeterminateRowKeys);
    }, [dataSource, selectedRowKeys, indeterminateRowKeys]);
    var renderDataSource = (0, react_1.useMemo)(function () {
        if ((hasFilter && depth === 1) || showSearch) {
            return dataSource
                .filter(function (item) {
                var title = item.title;
                return title.search(searchValue) !== -1;
            })
                .map(function (item) {
                var key = item.key, title = item.title, disabled = item.disabled, isFocus = item.isFocus, children = item.children, indeterminate = item.indeterminate, isSelected = item.isSelected, rest = tslib_1.__rest(item, ["key", "title", "disabled", "isFocus", "children", "indeterminate", "isSelected"]);
                var renderTitle = !searchValue
                    ? title
                    : title
                        .split(searchValue)
                        .join('<span style="color: #4c67ff">' + searchValue + '</span>');
                return tslib_1.__assign(tslib_1.__assign({ key: key, title: title, disabled: disabled, isFocus: isFocus, hasChild: !!children, indeterminate: indeterminate, isSelected: isSelected }, rest), { renderTitle: renderTitle });
            });
        }
        return dataSource.map(function (_a) {
            var key = _a.key, title = _a.title, disabled = _a.disabled, isFocus = _a.isFocus, children = _a.children, indeterminate = _a.indeterminate, isSelected = _a.isSelected, rest = tslib_1.__rest(_a, ["key", "title", "disabled", "isFocus", "children", "indeterminate", "isSelected"]);
            return tslib_1.__assign({ key: key, title: title, disabled: disabled, isFocus: isFocus, hasChild: !!children, indeterminate: indeterminate, isSelected: isSelected }, rest);
        });
    }, [dataSource, hasFilter, searchValue]);
    var onItemClick = function (item) {
        var disabled = item.disabled, key = item.key;
        if (!disabled) {
            if (_dataSource !== dataSource && _dataSource) {
                if (!_dataSource.find(function (_item) { return _item.key === item.key; })) {
                    _dataSource.unshift(tslib_1.__assign(tslib_1.__assign({}, item), { isFocus: true }));
                }
            }
            onItemFocus(key);
        }
    };
    var checkFocus = (0, react_1.useCallback)(function (key, hasChild, index) {
        if (defaultFocus && index === 0 && focusKeys.length === 0) {
            return hasChild;
        }
        var isFocus = focusKeys === null || focusKeys === void 0 ? void 0 : focusKeys.includes(key);
        if (!singleSelect) {
            isFocus = hasChild ? isFocus : false;
        }
        return isFocus;
    }, [focusKeys, singleSelect]);
    var allDisabled = (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === 0 || numberOfItemStatus.numberOfActiveItem === 0;
    var hasChildPanel = renderDataSource.every(function (item) { return !!item.hasChild; });
    var calcShowSearch = (((hasFilter && depth === 1) || showSearch) && dataSource.length !== 0) || loadChildren;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-selectable-container-item', {
            'anq-selectable-container-item-hide-title': hideTitle,
        }, className), style: !hasChildPanel || renderDataSource.length === 0 ? lastPanelStyle : {} },
        !hideTitle && (react_1.default.createElement("div", { className: "anq-cascader-panel-item anq-cascader-panel-header" },
            !hideSelectAll && !singleSelect && (react_1.default.createElement("div", { className: "anq-cascader-panel-left" },
                react_1.default.createElement(AnqCheckBox, { checked: (numberOfItemStatus.isCheckedAll && dataSource.length > 0) ||
                        // @ts-ignore
                        (((_a = dataSource === null || dataSource === void 0 ? void 0 : dataSource.parent) === null || _a === void 0 ? void 0 : _a.isSelected) && !allDisabled), indeterminate: (!numberOfItemStatus.isCheckedAll &&
                        numberOfItemStatus.indeterminateAll &&
                        dataSource.length > 0) ||
                        (
                        // @ts-ignore
                        (_b = dataSource === null || dataSource === void 0 ? void 0 : dataSource.parent) === null || _b === void 0 ? void 0 : _b.indeterminate), onClick: function () {
                        onSelectAll(!numberOfItemStatus.isCheckedAll);
                    }, disabled: allDisabled }))),
            react_1.default.createElement("div", { className: "anq-cascader-panel-right" },
                react_1.default.createElement("span", { className: "anq-cascader-panel-txt" }, title),
                !singleSelect && (react_1.default.createElement("span", null,
                    numberOfItemStatus.numberOfChecked,
                    "/",
                    dataSource.length))))),
        react_1.default.createElement("div", { className: "anq-cascader-content" },
            calcShowSearch && (react_1.default.createElement("div", { className: "anq-cascader-panel-filter" },
                react_1.default.createElement(Search, { defaultValue: searchValue, allowClear: true, onChange: function (e) {
                        _onSearch(e.target.value);
                    }, placeholder: placeholder || '请输入' }))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)({
                    'anq-cascader-panel-item-container': true,
                    'anq-cascader-panel-has-filter': hasFilter && dataSource.length !== 0,
                    'anq-cascader-panel-item-container-mt8': !calcShowSearch,
                }) }, renderDataSource === null || renderDataSource === void 0 ? void 0 :
                renderDataSource.map(function (item, index) {
                    var _a, _b;
                    var _c = item, key = _c.key, renderTitle = _c.renderTitle, title = _c.title, disabled = _c.disabled, hasChild = _c.hasChild;
                    var checked = selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys.includes(key);
                    var calcindeterminate = indeterminateRowKeys === null || indeterminateRowKeys === void 0 ? void 0 : indeterminateRowKeys.includes(key);
                    var isFocus = checkFocus(key, hasChild, index);
                    // 有renderCell且是最后一样没有children且单选时自定义
                    return (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                            'anq-cascader-panel-item': true,
                            'anq-cascader-panel-focus': isFocus,
                            'anq-cascader-panel-disabled': disabled,
                            'anq-cascader-panel-item-no-child': !hasChild,
                            'anq-cascader-panel-item-single': singleSelect,
                        }), key: "".concat(key).concat(renderTitle || title), style: renderCell && !hasChild ? { height: 'auto', width: '100%' } : {} },
                        !singleSelect && (react_1.default.createElement("div", { className: "anq-cascader-panel-left" },
                            react_1.default.createElement(AnqCheckBox
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                checked: !disabled && (checked || ((_a = dataSource === null || dataSource === void 0 ? void 0 : dataSource.parent) === null || _a === void 0 ? void 0 : _a.isSelected)), indeterminate: 
                                // @ts-ignore
                                !disabled && (calcindeterminate || ((_b = dataSource === null || dataSource === void 0 ? void 0 : dataSource.parent) === null || _b === void 0 ? void 0 : _b.calcindeterminate)), onClick: function () { return onSelect(index, !checked); }, disabled: disabled }))),
                        renderCell && !hasChild ? (react_1.default.createElement(react_1.default.Fragment, null, singleSelect ? (react_1.default.createElement("div", { style: { width: '100%' }, onClick: function () { return onItemClick(item); } }, renderCell(index, item, searchValue))) : (renderCell(index, item, searchValue)))) : (react_1.default.createElement("div", { className: "anq-cascader-panel-right", onClick: function () { return onItemClick(item); } },
                            react_1.default.createElement("div", { className: "anq-cascader-panel-txt anq-cascader-panel-title", dangerouslySetInnerHTML: { __html: renderTitle || title } }),
                            hasChild && react_1.default.createElement(DirectionRight_1.DirectionRight, { className: "anq-cascader-icon-right" })))));
                }),
                renderDataSource.length === 0 && (react_1.default.createElement("div", { className: "anq-cascader-panel-no-data" },
                    react_1.default.createElement(empty_state_1.default, null)))))));
};
exports.default = SelectableContainer;
//# sourceMappingURL=PanelItem.js.map